<template>
<div>
    <transition name="fade">
      <div id="image_block" v-if="currentPhoto != null">
            <div class="row">
            <div class="col-2">
                <div class="icon switch left position-relative" id="prevImg" @click="changePhoto(-1)" style="z-index: 1;"><span aria-hidden="true" data-icon=":"></span></div>
            </div>
            <div class="col-8" id="img">
                <transition name="fade">
                <img :src="`/${data.img[currentPhoto]}`" style="width:100vw; max-height: 96vh;">
                </transition>
            </div>
                <div class="col-2">
                    <div class="icon" id="closeImg" @click="closePhoto()"><span aria-hidden="true" data-icon="("></span></div>
                    <div class="icon switch" @click="changePhoto(1)"><span aria-hidden="true" data-icon=";"></span></div>
                </div>
            </div>
        </div>
    </transition>

    <section id="gallery_block">
        <div class="container-fluid">
            <div class="row"> 
                <div class="col-12" style="height: 15vh;">
                    <div class="container-fluid" style="z-index: 1;">
                        <div class="col-12 click-through pl-0 position-fixed" style="z-index:2;">
                            <div><img src="/img/balerija-top-logo.png" width="15%" :class="{ 'mobile-home-img': mobile }" style="margin-top: 1vh;padding-left: 15px;padding-right: 15px;"></div>
                            <router-link to="/#stage" class="back clickable"><span aria-hidden="true" data-icon="," ></span></router-link>
                        </div>
                        <div class="col-12 text-center click-through">
                            <div class="section_title clickable" id="center">
                                SKATUVE
                                <div class="title_nav">
                                <a href="#" class="pasakumi"><div class="dot"></div><div class="title">PASĀKUMI</div></a>
                                <a href="#" class="galerija active"><div class="dot"></div><div class="title">GALERIJA</div></a>
                                <a href="#" class="grupam"><div class="dot"></div><div class="title">GRUPĀM</div></a>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
                <div class="col-1">
                    <div id="gallery_title" v-if="data != null">
                        <div class="group">{{ data.event.nosaukums }}</div>
                        <div class="date">{{ formatDate(data.event.datums) }}</div>
                    </div>
                </div>
                <div class="col-10 row" id="images" v-if="data != null && !mobile">
                    <div class="col-4 images" v-for="(img, i) in data.img" :key="i" @click="viewPhoto(i)">
                        <img :src="`/${img}`" width="100%">
                        <div class="dot"></div>
                    </div>
                </div>
                <div class="col-12 row" v-else-if="data != null">
                    <div class="col-6 images" v-for="(img, i) in data.img" :key="i" @click="viewPhoto(i)">
                        <img :src="`/${img}`" width="100%">
                        <div class="dot"></div>
                    </div> 
                </div>
                <div class="col-1"></div>
                <div class="col-12" style="height: 15vh;"></div>
            </div>
        </div>
    </section>
</div>
</template>
<script>
export default {
    data()
    {
        return {
            data: null,
            id: null,
            currentPhoto: null,
            mobile: false
        }
    },
    beforeMount()
    {
        this.id = this.$route.params.id;
        this.loadGallery();
        this.isMobile();
        window.addEventListener('resize', () => {
            this.isMobile();
        });
    },
    methods: {
        isMobile: function()
        {
            if(window.innerWidth < 1280)
                this.mobile = true;
            else
                this.mobile = false;
        },
        loadGallery: function()
        {
            this.$http({
                url: `/gallery/${this.id}`,
                method: 'GET',
            })
            .then((res) => {
                this.data = res.data;

                console.log(this.data);
            }, () => {
                this.has_error = true
            })
        },
        viewPhoto: function(id)
        {
            this.currentPhoto = id; 
        },
        changePhoto: function(index)
        {

            if(index == 1 && this.currentPhoto < (this.data.img).length - 1)
            {
                this.currentPhoto += index;
            }
            else if(index == -1 && this.currentPhoto > 0)
                this.currentPhoto += index;

            console.log(`${this.currentPhoto}: ${index}`);
        },
        closePhoto: function()
        {
            this.currentPhoto = null;
        },
        formatDate: function(date)
        {
            date = new Date(date);

            var day = (date.getDate() < 10 ? '0' : '') + date.getDate();
            var month = ((date.getMonth()+1 < 10) ? '0' : '') + (date.getMonth()+1);

            return `${day}.${month}.${date.getFullYear()}`;
        }
    }
}
</script>